"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTag = exports.SeasonTagged = exports.ConstructionUseUntagged = exports.OccasionUntagged = exports.UsesUntagged = exports.UsesTagged = exports.Quality = exports.KnitWeaveType = exports.Knits = exports.Weaves = exports.ContentGeneral = exports.ContentSpecific = exports.ContentType = exports.Imperfections = exports.Pattern = exports.Colour = exports.Feel = exports.Border = exports.ColourTone = exports.Drape = exports.Weight = exports.Opacity = exports.Stretch = exports.KnitOrWoven = exports.BundleOrRoll = void 0;
var BundleOrRoll;
(function (BundleOrRoll) {
    BundleOrRoll["Roll"] = "Roll";
    BundleOrRoll["Bundle"] = "Bundle";
})(BundleOrRoll = exports.BundleOrRoll || (exports.BundleOrRoll = {}));
var KnitOrWoven;
(function (KnitOrWoven) {
    KnitOrWoven["Knit"] = "Knit";
    KnitOrWoven["Woven"] = "Woven";
})(KnitOrWoven = exports.KnitOrWoven || (exports.KnitOrWoven = {}));
exports.Stretch = {
    None: 'None',
    '2-way': '2-way',
    '4-way': '4-way'
};
var Opacity;
(function (Opacity) {
    Opacity["Sheer"] = "Sheer";
    Opacity["Semi-Sheer"] = "Semi-Sheer";
    Opacity["Semi-Opaque"] = "Semi-Opaque";
    Opacity["Opaque"] = "Opaque";
})(Opacity = exports.Opacity || (exports.Opacity = {}));
var Weight;
(function (Weight) {
    Weight["Light"] = "Light";
    Weight["Medium"] = "Medium";
    Weight["Heavy"] = "Heavy";
})(Weight = exports.Weight || (exports.Weight = {}));
var Drape;
(function (Drape) {
    Drape["Structured"] = "Structured";
    Drape["Crisp"] = "Crisp";
    Drape["Moderate"] = "Moderate";
    Drape["Relaxed"] = "Relaxed";
    Drape["Fluid"] = "Fluid";
})(Drape = exports.Drape || (exports.Drape = {}));
var ColourTone;
(function (ColourTone) {
    ColourTone["Light"] = "Light";
    ColourTone["Dark"] = "Dark";
    ColourTone["None"] = "";
})(ColourTone = exports.ColourTone || (exports.ColourTone = {}));
var Border;
(function (Border) {
    Border["Border"] = "Border";
    Border["None"] = "";
})(Border = exports.Border || (exports.Border = {}));
exports.Feel = {
    Cozy: {
        Soft: 'Soft',
        Warm: 'Warm',
        Fuzzy: 'Fuzzy'
    },
    Structure: {
        Rough: 'Rough',
        'Canvas-like': 'Canvas-like',
        Stiff: 'Stiff',
        Textured: 'Textured',
        Structured: 'Structured'
    },
    Luxurious: {
        Velvety: 'Velvety',
        Lacey: 'Lacey',
        Felted: 'Felted',
        Silky: 'Silky',
        Satiny: 'Satiny'
    },
    Sleek: {
        Smooth: 'Smooth',
        Shiny: 'Shiny',
        Slippery: 'Slippery',
        Slinky: 'Slinky',
        Cool: 'Cool'
    },
    Flowy: {
        Airy: 'Airy',
        Flouncy: 'Flouncy',
        Light: 'Light'
    }
};
exports.Colour = {
    Black: 'Black',
    White: 'White',
    Grey: 'Grey',
    Brown: 'Brown',
    Beige: 'Beige',
    Blue: 'Blue',
    Green: 'Green',
    Purple: 'Purple',
    Red: 'Red',
    Orange: 'Orange',
    Yellow: 'Yellow',
    Pink: 'Pink',
    Navy: 'Navy',
    Cream: 'Cream',
    Gold: 'Gold',
    Silver: 'Silver',
    Burgundy: 'Burgundy',
    Multi: 'Multi'
};
exports.Pattern = {
    Plaid: 'Plaid',
    'Polka Dots': 'Polka Dots',
    Stripes: 'Stripes',
    Pinstripe: 'Pinstripe',
    Floral: 'Floral',
    Geometric: 'Geometric',
    Abstract: 'Abstract',
    Paisley: 'Paisley',
    Damask: 'Damask',
    Chevron: 'Chevron',
    ZigZag: 'ZigZag',
    'Animal Print': 'Animal Print'
};
exports.Imperfections = {
    Discoloration: 'Discoloration',
    Run: 'Run',
    'Scented - Vintage': 'Scented - Vintage',
    'Scented - Washed': 'Scented - Washed',
    'Small Holes': 'Small Holes',
    Marks: 'Marks',
    'Corners Cut Out': 'Corners Cut Out',
    'Sample Hole': 'Sample Hole',
    'Odd Cut': 'Odd Cut'
};
var ContentType;
(function (ContentType) {
    ContentType["EstimatedSpecific"] = "Estimated";
    ContentType["EstimatedGeneral"] = "General";
    ContentType["Known"] = "Known";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
exports.ContentSpecific = {
    Spandex: 'Spandex',
    Cotton: 'Cotton',
    'Rayon From Bamboo': 'Rayon From Bamboo',
    Polyester: 'Polyester',
    Wool: 'Wool',
    Rayon: 'Rayon',
    Nylon: 'Nylon',
    Linen: 'Linen',
    Tencel: 'Tencel',
    Acrylic: 'Acrylic',
    'Organic Cotton': 'Organic Cotton',
    Acetate: 'Acetate',
    Silk: 'Silk',
    Modal: 'Modal',
    PVC: 'PVC',
    Hemp: 'Hemp',
    Lyocell: 'Lyocell',
    PU: 'PU',
    Cashmere: 'Cashmere'
};
exports.ContentGeneral = {
    'Natural Blend': 'Natural Blend',
    Natural: 'Natural',
    'Synthetic Blend': 'Synthetic Blend',
    Synthetic: 'Synthetic',
    Other: 'Other'
};
var Weaves;
(function (Weaves) {
    Weaves["Crushed Velvet"] = "Crushed Velvet";
    Weaves["Double Cloth Weave"] = "Double Cloth Weave";
    Weaves["Faux Fur"] = "Faux Fur";
    Weaves["Faux Suede"] = "Faux Suede";
    Weaves["French Terry"] = "French Terry";
    Weaves["Plain Weave"] = "Plain Weave";
    Weaves["Pleather Cotton Backing"] = "Pleather Cotton Backing";
    Weaves["Pleather Polyester Backing"] = "Pleather Polyester Backing";
    Weaves["Rib Weave"] = "Rib Weave";
    Weaves["Tapestry Weave"] = "Tapestry Weave";
    Weaves["Twill Weave"] = "Twill Weave";
    Weaves["Waffle Weave"] = "Waffle Weave";
    Weaves["Basket Weave"] = "Basket Weave";
    Weaves["Batting"] = "Batting";
    Weaves["Beaded"] = "Beaded";
    Weaves["Chiffon"] = "Chiffon";
    Weaves["Corduroy"] = "Corduroy";
    Weaves["Crepe"] = "Crepe";
    Weaves["Denim"] = "Denim";
    Weaves["Embroidery"] = "Embroidery";
    Weaves["Felt"] = "Felt";
    Weaves["Flanel"] = "Flanel";
    Weaves["Flanelette"] = "Flanelette";
    Weaves["Fleece"] = "Fleece";
    Weaves["Gauze"] = "Gauze";
    Weaves["Herringbone"] = "Herringbone";
    Weaves["Houndstooth"] = "Houndstooth";
    Weaves["Interfacing"] = "Interfacing";
    Weaves["Jacquard"] = "Jacquard";
    Weaves["Lace"] = "Lace";
    Weaves["Mesh"] = "Mesh";
    Weaves["Minky"] = "Minky";
    Weaves["Noil"] = "Noil";
    Weaves["Organza"] = "Organza";
    Weaves["Pinstripe"] = "Pinstripe";
    Weaves["PUL"] = "PUL";
    Weaves["Sateen"] = "Sateen";
    Weaves["Satin"] = "Satin";
    Weaves["Sequins"] = "Sequins";
    Weaves["Softshell"] = "Softshell";
    Weaves["Taffeta"] = "Taffeta";
    Weaves["Tulle"] = "Tulle";
    Weaves["Tweed"] = "Tweed";
    Weaves["Velvet"] = "Velvet";
    Weaves["Velveteen"] = "Velveteen";
    Weaves["Vinyl"] = "Vinyl";
})(Weaves = exports.Weaves || (exports.Weaves = {}));
var Knits;
(function (Knits) {
    Knits["Double Cloth Knit"] = "Double Cloth Knit";
    Knits["Faux Fur"] = "Faux Fur";
    Knits["French Terry"] = "French Terry";
    Knits["Jersey Fleece"] = "Jersey Fleece";
    Knits["Knitted Velour"] = "Knitted Velour";
    Knits["Pleather Cotton Backing"] = "Pleather Cotton Backing";
    Knits["Pleather Polyester Backing"] = "Pleather Polyester Backing";
    Knits["Rib Knit"] = "Rib Knit";
    Knits["Sport Mesh"] = "Sport Mesh";
    Knits["Terry Towel"] = "Terry Towel";
    Knits["Waffle Knit"] = "Waffle Knit";
    Knits["Fleece"] = "Fleece";
    Knits["Interfacing"] = "Interfacing";
    Knits["Interlock"] = "Interlock";
    Knits["Jersey"] = "Jersey";
    Knits["Lace"] = "Lace";
    Knits["Mesh"] = "Mesh";
    Knits["Microfibre"] = "Microfibre";
    Knits["Sequins"] = "Sequins";
    Knits["Tulle"] = "Tulle";
})(Knits = exports.Knits || (exports.Knits = {}));
var KnitWeaveCategory;
(function (KnitWeaveCategory) {
    KnitWeaveCategory["Light"] = "Light";
    KnitWeaveCategory["Standard"] = "Standard";
    KnitWeaveCategory["Heavy"] = "Heavy";
})(KnitWeaveCategory || (KnitWeaveCategory = {}));
exports.KnitWeaveType = {
    [KnitOrWoven.Knit]: {
        [KnitWeaveCategory.Standard]: {
            [Knits['Double Cloth Knit']]: Knits['Double Cloth Knit'],
            [Knits['Rib Knit']]: Knits['Rib Knit'],
            [Knits['Interlock']]: Knits['Interlock'],
            [Knits['Microfibre']]: Knits['Microfibre'],
            [Knits['Jersey']]: Knits['Jersey'],
            [Knits['Jersey Fleece']]: Knits['Jersey Fleece'],
            [Knits['Waffle Knit']]: Knits['Waffle Knit']
        },
        [KnitWeaveCategory.Light]: {
            [Knits['Tulle']]: Knits['Tulle'],
            [Knits['Sport Mesh']]: Knits['Sport Mesh'],
            [Knits['Lace']]: Knits['Lace'],
            [Knits['Mesh']]: Knits['Mesh'],
            [Knits['Interfacing']]: Knits['Interfacing']
        },
        [KnitWeaveCategory.Heavy]: {
            [Knits['Fleece']]: 'Fleece',
            [Knits['French Terry']]: 'French Terry',
            [Knits['Knitted Velour']]: 'Knitted Velour',
            [Knits['Sequins']]: 'Sequins',
            [Knits['Faux Fur']]: 'Faux Fur',
            [Knits['Terry Towel']]: 'Terry Towel',
            [Knits['Pleather Cotton Backing']]: 'Pleather Cotton Backing',
            [Knits['Pleather Polyester Backing']]: 'Pleather Polyester Backing'
        }
    },
    [KnitOrWoven.Woven]: {
        [KnitWeaveCategory.Standard]: {
            [Weaves['Plain Weave']]: Weaves['Plain Weave'],
            [Weaves['Double Cloth Weave']]: Weaves['Double Cloth Weave'],
            [Weaves['Rib Weave']]: Weaves['Rib Weave'],
            [Weaves['Basket Weave']]: Weaves['Basket Weave'],
            [Weaves['Jacquard']]: Weaves['Jacquard'],
            [Weaves['Herringbone']]: Weaves['Herringbone'],
            [Weaves['Pinstripe']]: Weaves['Pinstripe'],
            [Weaves['Houndstooth']]: Weaves['Houndstooth'],
            [Weaves['Beaded']]: Weaves['Beaded'],
            [Weaves['Embroidery']]: Weaves['Embroidery'],
            [Weaves['Crushed Velvet']]: Weaves['Crushed Velvet'],
            [Weaves['Felt']]: Weaves['Felt'],
            [Weaves['Minky']]: Weaves['Minky'],
            [Weaves['Velvet']]: Weaves['Velvet'],
            [Weaves['Velveteen']]: Weaves['Velveteen'],
            [Weaves['PUL']]: Weaves['PUL'],
            [Weaves['Tweed']]: Weaves['Tweed']
        },
        [KnitWeaveCategory.Light]: {
            [Weaves['Chiffon']]: Weaves['Chiffon'],
            [Weaves['Crepe']]: Weaves['Crepe'],
            [Weaves['Sateen']]: Weaves['Sateen'],
            [Weaves['Satin']]: Weaves['Satin'],
            [Weaves['Mesh']]: Weaves['Mesh'],
            [Weaves['Lace']]: Weaves['Lace'],
            [Weaves['Gauze']]: Weaves['Gauze'],
            [Weaves['Noil']]: Weaves['Noil'],
            [Weaves['Organza']]: Weaves['Organza'],
            [Weaves['Tulle']]: Weaves['Tulle'],
            [Weaves['Taffeta']]: Weaves['Taffeta'],
            [Weaves['Batting']]: Weaves['Batting'],
            [Weaves['Interfacing']]: Weaves['Interfacing']
        },
        [KnitWeaveCategory.Heavy]: {
            [Weaves['Flanel']]: Weaves['Flanel'],
            [Weaves['Flanelette']]: Weaves['Flanelette'],
            [Weaves['Fleece']]: Weaves['Fleece'],
            [Weaves['French Terry']]: Weaves['French Terry'],
            [Weaves['Waffle Weave']]: Weaves['Waffle Weave'],
            [Weaves['Softshell']]: Weaves['Softshell'],
            [Weaves['Faux Suede']]: Weaves['Faux Suede'],
            [Weaves['Corduroy']]: Weaves['Corduroy'],
            [Weaves['Denim']]: Weaves['Denim'],
            [Weaves['Sequins']]: Weaves['Sequins'],
            [Weaves['Twill Weave']]: Weaves['Twill Weave'],
            [Weaves['Tapestry Weave']]: Weaves['Tapestry Weave'],
            [Weaves['Vinyl']]: Weaves['Vinyl'],
            [Weaves['Pleather Cotton Backing']]: Weaves['Pleather Cotton Backing'],
            [Weaves['Pleather Polyester Backing']]: Weaves['Pleather Polyester Backing'],
            [Weaves['Faux Fur']]: Weaves['Faux Fur']
        }
    }
};
exports.Quality = {
    Performance: {
        Waterproof: 'Waterproof',
        DWR: 'DWR',
        WaterResistant: 'Water Resistant',
        Goretex: 'Goretex',
        Waxed: 'Waxed',
        VirginWool: 'Virgin Wool',
        FireRetardent: 'Fire Retardent',
        RawSilk: 'Raw Silk',
        Chitosante: 'Chitosante',
        SewIn: 'Sew In',
        IronOn: 'Iron On'
    },
    Aesthetic: {
        Vintage: 'Vintage',
        Glitter: 'Glitter',
        Tubular: 'Tubular',
        Crinkle: 'Crinkle',
        ShortHair: 'Short Hair',
        UnbleachedOrUndyed: 'Unbleached/Undyed',
        MediumHair: 'Medium Hair',
        QuiltedTop: 'Quilted Top',
        LongHair: 'Long Hair',
        Brushed: 'Brushed',
        Metallic: 'Metallic'
    }
};
exports.UsesTagged = {
    Suiting: 'Suiting',
    'Sports Wear': 'Sports Wear',
    'Casual Wear': 'Casual Wear',
    'Formal Wear': 'Formal Wear',
    Lingerie: 'Lingerie',
    'Home Decor': 'Home Decor',
    Swimwear: 'Swimwear',
    Costumes: 'Costumes',
    Accessories: 'Accessories',
    Finishing: 'Finishing',
    Interfacing: 'Interfacing',
    Other: 'Other'
};
exports.UsesUntagged = {
    Suiting: {
        Blazers: 'Blazers',
        Trousers: 'Trousers',
        Coats: 'Coats'
    },
    'Sports Wear': {
        Shorts: 'Shorts',
        Pants: 'Pants',
        Jerseys: 'Jerseys',
        Leggings: 'Leggings'
    },
    Lingerie: {
        Bras: 'Bras',
        Underwear: 'Underwear',
        Bodysuit: 'Bodysuit'
    },
    'Home Decor': {
        'Indoor Upholstery': 'Indoor Upholstery',
        'Outdoor Upholstery': 'Outdoor Upholstery',
        Curtains: 'Curtains'
    },
    Finishing: {
        Interfacing: 'Interfacing',
        Lining: 'Lining',
        Batting: 'Batting',
        Overlay: 'Overlay'
    },
    'Casual Wear': {
        Shirts: 'Shirts',
        Pants: 'Pants',
        Shorts: 'Shorts',
        Sweaters: 'Sweaters',
        Skirts: 'Skirts',
        Dresses: 'Dresses',
        Jacket: 'Jacket'
    },
    'Formal Wear': {
        Dresses: 'Dresses',
        Blouses: 'Blouses',
        Skirts: 'Skirts',
        'Dress Shirts': 'Dress Shirts'
    },
    'Lounge Wear': {
        Pyjamas: 'Pyjamas',
        Nightgown: 'Nightgown',
        Sweats: 'Sweats',
        Robes: 'Robes',
        Joggers: 'Joggers',
        Hoodies: 'Hoodies'
    },
    OTHER: {
        Swimwear: 'Swimwear',
        Costumes: 'Costumes',
        Accessories: 'Accessories'
    }
};
exports.OccasionUntagged = {
    Everyday: {
        Casual: 'Casual',
        Formal: 'Formal',
        Athletic: 'Athletic',
        Lounge: 'Lounge',
        Lingerie: 'Lingerie'
    },
    Special: {
        Bridal: 'Bridal',
        'Event / Gala': 'Event / Gala',
        'Resort / Vacation': 'Resort / Vacation'
    },
    'Subculture & Community': {
        Costumes: 'Costumes',
        Historical: 'Historical',
        Cosplay: 'Cosplay',
        Drag: 'Drag'
    },
    OTHER: {
        'Upcycle / Repurpose': 'Upcycle / Repurpose'
    }
};
exports.ConstructionUseUntagged = {
    Apparel: {
        Dressmaking: 'Dressmaking',
        Suiting: 'Suiting',
        Lingerie: 'Lingerie',
        Swimwear: 'Swimwear'
    },
    'Active & Outerwear': {
        Sportswear: 'Sportswear',
        Outerwear: 'Outerwear'
    },
    'Home & Craft': {
        'Home Decor': 'Home Decor',
        Quilting: 'Quilting',
        'Art & Craft': 'Art & Craft',
        Finishing: 'Finishing'
    }
};
exports.SeasonTagged = {
    Seasons: {
        'Spring / Summer': 'Spring / Summer',
        'Fall / Winter': 'Fall / Winter',
        'All Season': 'All Season'
    }
};
exports.MediaTag = {
    Unboxing: 'Unboxing',
    'Daily Finds': 'Daily Finds',
    'Name the Fabric': 'Name the Fabric',
    None: 'None'
};
//# sourceMappingURL=fabricAttributes.js.map